import FirebaseContext, { withFirebase } from './context'
// eslint-disable-next-line
import Firebase from './firebase'

export default Firebase

export { FirebaseContext, withFirebase }
